import React from 'react';
import PropTypes from 'prop-types';

import PopupV3 from '../../Popup/PopupV3';

import styles from './monthlyToAnnualSuccessPopup.scss';

const MonthlyToAnnualSuccessPopup = ({ onCloseClick, renewalDate }) => {
    const handleCloseClick = () => {
        onCloseClick();
    };

    const formattedRenewal = renewalDate || '';
    const message = (
        <>
            <div>
                Congratulations! You are now able to enjoy all of the benefits of an annual Power membership.
            </div>
            {formattedRenewal && (
                <div className={styles.renewalMessage}>
                    Your plan will renew annually on {formattedRenewal}. Check your inbox for a confirmation email with all the details.
                </div>
            )}
        </>
    );

    return (
        <PopupV3
            isOpen
            type="success"
            title="Upgrade successful!"
            message={message}
            customContent
            confirmButtonLabel="Close"
            showCancelButton={false}
            onConfirmClick={handleCloseClick}
            className={styles.upgradeSuccessPopup}
        />
    );
};

MonthlyToAnnualSuccessPopup.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    renewalDate: PropTypes.string,
};

MonthlyToAnnualSuccessPopup.defaultProps = {
    renewalDate: '',
};

export default MonthlyToAnnualSuccessPopup;
